import { useEffect, useState } from "react";

const navItems = [
  { label: "首页", href: "#home" },
  { label: "今日看点", href: "#featured" },
  { label: "话题广场", href: "#square" },
  { label: "观点擂台", href: "#arena" },
  { label: "热议榜", href: "#ranking" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          <h1 className="flex items-center gap-2 shrink-0">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                  黑料看点
                </span>
                <span className="font-label text-[10px] md:text-xs tracking-widest text-foreground-500">
                  HOT TOPIC WATCH
                </span>
              </span>
            </a>
          </h1>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#contact"
              className="hidden md:inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
            >
              <i className="ri-chat-3-line"></i>
              参与讨论
            </a>
            <button
              type="button"
              onClick={() => setOpen((prev) => !prev)}
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="flex flex-col px-4 py-3" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md px-3 py-3 font-label text-sm text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-chat-3-line"></i>
              参与讨论
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}